import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Filter, IFilter } from "./Filter";

interface Iprops {
    toast: any,
    reload: boolean,
    reloadData: () => void,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({
        data: [],
        count: 0,
        loading: false
    });
    const [text, setText] = useState<string | null>(null);
    const [historyDialog, setHistoryDialog] = useState(false);
    const [historyLogs, setHistoryLogs] = useState<any[]>([]);
    const [leads, setLeads] = useState<any>([]);
    const [leadsDialog, setLeadsDialog] = useState(false);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: "id",
        sortOrder: -1
    });

    const [filter, setFilter] = useState<IFilter>({
        fromDate: new Date(),
        toDate: new Date()
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload, filter]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const loadTableData = async () => {
        if (filter.fromDate && filter.toDate) {
            const from = new Date(filter.fromDate);
            const to = new Date(filter.toDate);
            from.setHours(0, 0, 0, 0);
            to.setHours(0, 0, 0, 0);
            if (to < from) {
                props.toast.current.show({
                    severity: "warn",
                    summary: "Date Error",
                    detail: "To Date must be greater than or equal to From Date",
                    life: 3000
                });
                return;
            }
        }
        setTableData((prev: any) => ({ ...prev, loading: true }));
        const query =
            `lazyParams=${JSON.stringify(lazyParams)}` +
            `${text ? "&text=" + text : ""}` +
            `${filter.name ? "&name=" + filter.name : ""}` +
            `${filter.fromDate ? "&fromDate=" + format(filter.fromDate, "yyyy-MM-dd") : ""}` +
            `${filter.toDate ? "&toDate=" + format(filter.toDate, "yyyy-MM-dd") : ""}`;
        const response = await Fetch("User/loginhistory", "GET", null, query, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({
                data: data.users,
                count: data.count,
                loading: false
            });
        } else {
            setTableData((prev: any) => ({ ...prev, loading: false }));
        }
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: "uppercase", letterSpacing: 1 }}>
                        Login History
                    </h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
            </div>
        </div>
    );


    const openHistory = (rowData: any) => {
        setHistoryLogs(rowData.logs);
        setHistoryDialog(true);
    };

    const showLeads = async (rowData: any) => {
        if (!rowData.loginHistoryId) return;
        const response = await Fetch(
            `User/leadsByLoginHistory?loginHistoryId=${rowData.loginHistoryId}`,
            "GET",
            null,
            null,
            props.toast
        );
        if (response) {
            const data = await response.json();
            setLeads(data);
            setLeadsDialog(true);
        }
    };

    const leadBodyTemplate = (rowData: any) => {
        const count = rowData.leadAssignedCount ?? 0;
        return (
            <Button
                label={count.toString()}
                className="p-button-text p-button-sm"
                disabled={count === 0}
                onClick={() => showLeads(rowData)}
            />
        );
    };


    const actionBodyTemplate = (rowData: any) => {
        if (rowData.loginCount <= 0) return "-";
        return (
            <Button
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={() => openHistory(rowData)}
            />
        );
    };

    return (
        <>
            <Filter
                header={<div>Filter</div>}
                loading={tableData.loading}
                filter={filter}
                setFilter={setFilter}
            />
            <DataTable
                style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
                ref={dt}
                size="small"
                stripedRows
                scrollable
                scrollHeight="75vh"
                value={tableData.data}
                lazy
                dataKey="id"
                paginator
                first={lazyParams.first}
                rows={lazyParams.rows}
                rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count}
                onPage={onPage}
                onSort={onSort}
                sortField={lazyParams.sortField}
                sortOrder={lazyParams.sortOrder}
                emptyMessage="No Login History found."
                header={header}
                loading={tableData.loading}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="name" header="Name" sortable />
                <Column field="email" header="Email" sortable />
                <Column field="loginCount" header="Login Count" />
                <Column field="status" header="Status" />
                <Column body={actionBodyTemplate} header="History" />

            </DataTable>


            <Dialog
                header="Login History"
                visible={historyDialog}
                style={{ width: "50vw" }}
                onHide={() => setHistoryDialog(false)}
            >
                <DataTable
                    value={historyLogs}
                    size="small"
                    stripedRows
                >
                    <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} />
                    <Column
                        field="loginTime"
                        header="Login Time"
                        body={(row: any) =>
                            row.loginTime
                                ? format(new Date(row.loginTime + "Z"), "dd MMM yyyy hh:mm a")
                                : ""
                        }
                    />
                    <Column
                        field="logoutTime"
                        header="Logout Time"
                        body={(row: any) =>
                            row.logoutTime
                                ? format(new Date(row.logoutTime + "Z"), "dd MMM yyyy hh:mm a")
                                : "Not Logged Out Yet"
                        }
                    />
                    <Column
                        field="leadAssignedCount"
                        header="Lead Assigned"
                        body={leadBodyTemplate}
                    />
                    <Column field="ipAddress" header="IP Address" />
                    <Column field="browser" header="Browser" />
                </DataTable>
            </Dialog>

            <Dialog
                header="Assigned Leads"
                visible={leadsDialog}
                style={{ width: "60vw" }}
                onHide={() => setLeadsDialog(false)}
            >
                <DataTable value={leads} size="small" stripedRows>
                    <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="contactName" header="Contact Name" />
                    <Column field="contactEmail" header="Contact Email" />
                    <Column field="assignedUser" header="Assigned User" />
                    <Column
                        field="createdAt"
                        header="Created At"
                        body={(row: any) =>
                            row.createdAt
                                ? format(new Date(row.createdAt + "Z"), "dd MMM yyyy hh:mm a")
                                : ""
                        }
                    />
                    <Column
                        header="Type"
                        body={(row: any) => (
                            <span
                                style={{
                                    color: row.reassignelead ? "#f59e0b" : "#22c55e",
                                    fontWeight: 600
                                }}
                            >
                                {row.reassignelead ? "Reassigned" : "Assigned"}
                            </span>
                        )}
                    />
                </DataTable>
            </Dialog>
            <ConfirmDialog />

        </>
    );
};